import { render, staticRenderFns } from "./Composicao.vue?vue&type=template&id=31804fc2&scoped=true"
import script from "./Composicao.vue?vue&type=script&lang=js"
export * from "./Composicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31804fc2",
  null
  
)

export default component.exports